import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CampaignCurrency, VALUE_FIRST_CURRENCIES } from '../../../onboarding-value-first/services/value-first-onboarding.types';
import { ValueFirstAgencyService } from '../../services/value-first-agency.service';

@Component({
  selector: 'vfa-manual-step',
  templateUrl: './manual-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VfaManualStep {
  readonly onboarding = inject(ValueFirstAgencyService);
  readonly currencies = VALUE_FIRST_CURRENCIES;
  readonly name = signal(this.onboarding.draft().agency?.name ?? '');

  onName(event: Event): void {
    this.name.set((event.target as HTMLInputElement).value);
    this.onboarding.clearError();
  }

  chooseCurrency(currency: CampaignCurrency): void {
    this.onboarding.setCurrency(currency);
  }

  submit(event: Event): void {
    event.preventDefault();
    this.onboarding.submitManual(this.name());
  }
}
